import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { ButtonGroup, ButtonToolbar, FormLabel, FormSelect, InputGroup } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Modal from "react-bootstrap/Modal";
import BootstrapTable from "react-bootstrap/Table";
import { FormattedMessage, injectIntl } from "react-intl";
import { coalesce } from "../../../utils/ObjectUtils";
import RichTextEditor from "../../common/richTextEditor/RichTextEditor";

class CreateEditResultDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { addActionFieldVisible: false };
  }

  render() {
    const { result, actionFields, onChange, onCancel, onSave, locale, intl } = this.props;

    const newMode = result.id === undefined;
    const isFormValid = result.name["en"] && result.name["de"];
    const availableActionFields = actionFields.filter((af) => !result.actionFields.map((a) => a.id).includes(af.id));

    return (
      <Modal show size="xl">
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id={`indicator.management.${newMode ? "new" : "edit"}.active.element`} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup  className="mb-3">
            <FormLabel>
              <FormattedMessage id="indicator.management.action.fields" /> *
            </FormLabel>
            <BootstrapTable>
              <tbody>
                {result.actionFields.map((af) => (
                  <tr key={"row" + af.id}>
                    <td>{af.name[locale]}</td>
                    <td>
                      {result.actionFields && result.actionFields.length > 1 && (
                        <Button
                          variant="link"
                          title={intl.formatMessage({ id: "app.common.action.delete" })}
                          onClick={() => {
                            result.actionFields = result.actionFields.filter((actField) => actField.id !== af.id);
                            onChange(result);
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </BootstrapTable>
            {this.state.addActionFieldVisible && (
              <>
                <FormGroup  className="mb-3">
                  <InputGroup>
                    <FormSelect
                      onChange={(event) => {
                        this.setState({ selectedActionFieldId: event.target.value });
                      }}
                      value={this.state.selectedActionFieldId || ""}
                    >
                      <option key={""} value={""}>
                        {intl.formatMessage({ id: "indicator.management.choose.action.field" })}
                      </option>
                      {availableActionFields.map((af) => (
                        <option key={"option" + af.id} value={af.id}>
                          {af.name[locale]}
                        </option>
                      ))}
                    </FormSelect>
                    <ButtonToolbar>
                      <ButtonGroup>
                        <Button
                          variant="danger"
                          onClick={() => {
                            this.setState({ addActionFieldVisible: false });
                          }}
                          title={intl.formatMessage({ id: "app.common.action.cancel" })}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                        <Button
                          variant="success"
                          title={intl.formatMessage({ id: "app.common.action.take.over" })}
                          onClick={() => {
                            const actionField = actionFields.find((af) => af.id === this.state.selectedActionFieldId);
                            result.actionFields.push(actionField);
                            onChange(result);
                            this.setState({
                              selectedActionFieldId: "",
                              addActionFieldVisible: false
                            });
                          }}
                          disabled={!this.state.selectedActionFieldId}
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </Button>
                      </ButtonGroup>
                    </ButtonToolbar>
                  </InputGroup>
                </FormGroup>
              </>
            )}
            {!this.state.addActionFieldVisible && (
              <Button onClick={() => this.setState({ addActionFieldVisible: true })}>
                <FormattedMessage id="app.common.action.add" />
              </Button>
            )}
          </FormGroup>
          <FormGroup  className="mb-3">
            <FormLabel>
              <FormattedMessage id="app.common.name.german" /> *
            </FormLabel>
            <FormControl
              type="text"
              name="nameDe"
              value={coalesce(result.name.de, "")}
              onChange={(event) => {
                result.name.de = event.target.value;
                onChange(result);
              }}
            />
          </FormGroup>
          <FormGroup  className="mb-3">
            <FormLabel>
              <FormattedMessage id="app.common.name.english" />*
            </FormLabel>
            <FormControl
              type="text"
              name="nameEn"
              value={coalesce(result.name.en, "")}
              onChange={(event) => {
                result.name.en = event.target.value;
                onChange(result);
              }}
            />
          </FormGroup>
          <FormGroup  className="mb-3">
            <FormLabel>
              <FormattedMessage id="indicator.management.result.description.german" />
            </FormLabel>
            <RichTextEditor
              onTextChange={(text) => {
                result.description.de = text;
                onChange(result);
              }}
              htmlContent={result.description && result.description.de ? result.description.de : ""}
            />
          </FormGroup>
          <FormGroup  className="mb-3">
            <FormLabel>
              <FormattedMessage id="indicator.management.result.description.english" /> *
            </FormLabel>
            <RichTextEditor
              onTextChange={(text) => {
                result.description.en = text;
                onChange(result);
              }}
              htmlContent={result.description && result.description.en ? result.description.en : ""}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onCancel}>
            <FormattedMessage id="app.common.action.cancel" />
          </Button>
          <Button onClick={() => onSave()} disabled={!isFormValid}>
            <FormattedMessage id="app.common.action.save" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

CreateEditResultDialog.propTypes = {
  show: PropTypes.bool,
  result: PropTypes.object.isRequired,
  actionFields: PropTypes.arrayOf(PropTypes.object),

  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,

  locale: PropTypes.string.isRequired
};

export default injectIntl(CreateEditResultDialog);
